import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import CloudPhonePage from "../pages/cloud-phone/page";
import ArmCloudPage from "../pages/arm-cloud/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <CloudPhonePage />,
  },
  {
    path: "/arm-cloud",
    element: <ArmCloudPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;